<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'通知情報管理' | translate}}</h1>

  <div class="basic-button" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="openAddDialog()">
      <mat-icon>add</mat-icon>
      <span>{{'追加' | translate}}</span>
    </button>

    <button mat-raised-button color="warn" (click)="deleteData()" [disabled]="!selection.selected.length">
      <mat-icon>delete</mat-icon>
      <span>{{'削除' | translate}}</span>
    </button>
  </div>
</div>

<div class="filter-field" fxLayout="row" fxLayoutGap="20px">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
  <mat-form-field fxFlex="15%">
    <mat-select placeholder="{{'プロジェクト' | translate}}" id="projectId" (selectionChange)="applyFilterProject($event)">
      <mat-option [value]= ""></mat-option>
      <mat-option *ngFor="let project of projects" [value]="project.project_id">
        {{ project.project_name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field fxFlex="15%">
    <mat-select placeholder="{{'通知種別' | translate}}" id="type" (selectionChange)="applyFilterType($event)">
      <mat-option *ngFor="let noticeType of noticeTypes" [value]="noticeType.type">
        {{ noticeType.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef> No. </th>
      <td mat-cell *matCellDef="let notice; let i = index"> {{ (i + 1) + (paginator.pageSize * paginator.pageIndex) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef> {{'編集' | translate}} </th>
      <td mat-cell *matCellDef="let notice">
        <button mat-button color="primary" (click)="openEditDialog(notice)">
          <mat-icon>create</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox color="primary" (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()"
          [aria-label]="checkboxLabel()">
        </mat-checkbox>
        <span> {{'全' | translate}} </span>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox color="primary" (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="projects">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'プロジェクトID' | translate}} </th>
      <td mat-cell *matCellDef="let notice">
        {{ notice.project_ids[0] }}
        <ng-container *ngIf="notice.project_ids.length > 1">{{'、他' | translate}}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'通知種別' | translate}} </th>
      <td mat-cell *matCellDef="let notice">
        <mat-icon *ngIf="notice.notice_type=='info'" class="material-icons color_info">info</mat-icon>
        <mat-icon *ngIf="notice.notice_type=='warn'" class="material-icons color_warn">warning</mat-icon>
        <mat-icon *ngIf="notice.notice_type=='err'" class="material-icons color_err">error</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'日時' | translate}} </th>
      <td mat-cell *matCellDef="let notice"> {{ notice.created.toDate() | date: 'yyyy/MM/dd HH:mm:ss' }} </td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'タイトル' | translate}} </th>
      <td mat-cell *matCellDef="let notice">
        {{ notice.notice_title }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>